import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  BreadcrumbModule,
  EmptyStateModule,
  MainContentModule,
  PaginatorModule,
  SidebarModule,
  TableModule,
  StatusModule,
  AlertModule,
  LoaderModule,
  ModalModule
} from '@michelin/theme';
import { CreateCamSpecComponent } from './components/create-cam-spec/create-cam-spec.component';
import { CreateCamSpecLineComponent } from './components/create-cam-spec-line/create-cam-spec-line.component';
import { AssetManagementModule } from '../asset-management/asset-management.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SharedModule } from 'src/app/shared/shared.module';
import { ViewEditCamSpecComponent } from './components/view-edit-cam-spec/view-edit-cam-spec.component';
import { ViewEditCamSpecLineComponent } from './components/view-edit-cam-spec-line/view-edit-cam-spec-line.component';

@NgModule({
  declarations: [CreateCamSpecComponent, CreateCamSpecLineComponent, ViewEditCamSpecComponent, ViewEditCamSpecLineComponent],
  exports: [CreateCamSpecComponent, CreateCamSpecLineComponent, ViewEditCamSpecComponent, ViewEditCamSpecLineComponent],
  imports: [
    TableModule,
    BreadcrumbModule,
    EmptyStateModule,
    PaginatorModule,
    CommonModule,
    RouterModule,
    MainContentModule,
    SidebarModule,
    AssetManagementModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    SharedModule,
    MatCardModule,
    StatusModule,
    AlertModule,
    LoaderModule,
    ModalModule,
    BreadcrumbModule
  ],
  providers: [DatePipe]
})
export class CamSpecificationModule {}
